import React, { useState, useRef, useEffect } from "react";
import { PostAPI, GetAPI } from "../../../hooks/Service";

const MyAccountCard = ({ BillInfo, loadPanelVisible }) => {
  // const [BillData, setBill] = useState([]);

  // useEffect(() => {
  //     let token = localStorage.getItem('trade_plus_token');
  //     const CallFun = async () => {
  //         let headers = {
  //             Authorization: "Bearer " + token
  //         }
  //         let params = '';
  //         let resultResponse = await PostAPI('Tplus/MyBill', params, headers);
  //         if (resultResponse.status) {
  //             setBill(resultResponse.result)
  //         }
  //     }
  //     if (token) {
  //         CallFun();
  //     }
  // }, [invoice])
  return (
    <div className="lg:px-10 px-3 pb-8">
      <div className="card-style justify-between">
        <div className="Account-style lg:px-12 px-3 back-forword-btn rounded-2xl lg:pt-8 pt-3">
          {loadPanelVisible ? (
            <div role="status" className="position-loading">
              <svg
                aria-hidden="true"
                className="flex w-12 h-12 items-center justify-center text-gray-200 animate-spin fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <div>
              <div className="flex justify-between mb-2">
                <div>
                  <div className="text-[#3491FF] card-font underline underline-offset-1">
                    Our Bank Account Details
                  </div>
                  <p className="mt-2 card-font text-[#3D3D3D]">
                    (Should you prefer to deposit the cheque directly.)
                  </p>
                </div>
              </div>
              <div className="flex mb-2 card-font mt-4">
                <div className="text-[#3D3D3D]">Account Name :</div>
                <div className="font-bold ml-3 text-[#3D3D3D]">
                  SECMARK CONSULTANCY LTD.
                </div>
              </div>
              <div className="flex mb-2 card-font">
                <div className="text-[#3D3D3D]">Bank :</div>
                <div className="font-bold ml-3 text-[#3D3D3D]">
                  State Bank of India
                </div>
              </div>
              <div className="flex mb-2 card-font">
                <div className="text-[#3D3D3D]">Branch :</div>
                <div className="font-bold ml-3 text-[#3D3D3D]">
                  Borivali West
                </div>
              </div>
              <div className="flex mb-2 card-font">
                <div className="text-[#3D3D3D]">IFSC Code :</div>
                <div className="font-bold ml-3 text-[#3D3D3D]">SBIN0000551</div>
              </div>
              <div className="flex card-font mb-8">
                <div className="text-[#3D3D3D]">A/C No :</div>
                <div className="font-bold ml-3 text-[#3D3D3D]">39744127423</div>
              </div>
            </div>
          )}
        </div>

        <div className="gap-style lg:w-1/5 w-1/9"></div>

        <div className="Account-style lg:px-12 px-3 back-forword-btn rounded-2xl lg:pt-8 pt-3">
          {loadPanelVisible ? (
            <div role="status" className="position-loading">
            <svg
              aria-hidden="true"
              className="flex w-12 h-12 items-center justify-center text-gray-200 animate-spin fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span className="sr-only">Loading...</span>
          </div>
          ):(<div>
            <div className="flex justify-between mb-2">
              <div>
                <div className="text-[#3491FF] text-lg  underline underline-offset-1">
                  SecMark Details
                </div>
              </div>
            </div>
            <div className="flex mb-2 card-font">
              <div className="text-[#3D3D3D]">GST ID :</div>
              <div className="font-bold ml-3 text-[#3D3D3D]">
                27AACCN0286A1ZV
              </div>
            </div>
            <div className="flex mb-2 card-font">
              <div className="text-[#3D3D3D]">PAN No :</div>
              <div className="font-bold ml-3 text-[#3D3D3D]">AAAAA1234A</div>
            </div>
          </div>)}
        </div>
      </div>
      <div className=" py-10">
        <div className="mb-2 card-style text-[#3D3D3D]">
          Please email the deposit details to us along with :
        </div>
        <div className="mb-2 card-style text-[#3D3D3D]">Deposit Amount</div>
        <div className="mb-2 card-style text-[#3D3D3D]">
          Amount of TDS Deducted, if any
        </div>
        <div className="mb-2 card-style text-[#3D3D3D]">Cheque No</div>
        <div className="mb-2 card-style text-[#3D3D3D]">Cheque No</div>
        <div className="mb-2 card-style text-[#3D3D3D]">Date of Deposit</div>
        <div className="mb-2 card-style text-[#3D3D3D]">
          If possible, forward a scanned copy of pay-in slip
        </div>
      </div>
      {/* <div className='flex justify-end '>
            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="50" height="50" rx="8" fill="#3491FF"/>
            <path d="M22.57 18.9297L16.5 24.9997L22.57 31.0697" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M33.4999 25H16.6699" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div> */}
    </div>
  );
};

export default MyAccountCard;
